import axios from 'axios';
import { installRateLimitRetry } from './rateLimitRetry';

/** Purpose: remove whitespace/trailing slashes from a configured API URL. Why: keeps URL joining consistent across environments. */
const normalizeUrl = (url) => {
  if (!url) return '';
  return url.trim().replace(/\/+$/, '');
};

/** Purpose: choose the API origin for this app. Why: supports explicit deployment URLs, local split-port development, and same-origin production hosting. */
const resolveApiBaseUrl = () => {
  const envUrl = normalizeUrl(process.env.REACT_APP_API_URL);
  if (envUrl) {
    return envUrl;
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;

    // In local development the React app runs on :3001 while the API runs on :3000.
    if (
      (hostname === 'localhost' || hostname === '127.0.0.1') &&
      port &&
      port !== '3000'
    ) {
      return `${protocol}//${hostname}:3000`;
    }
  }

  // Fallback to same-origin API when the app and API are served together.
  return '';
};

export const API_BASE_URL = resolveApiBaseUrl();

axios.defaults.baseURL = API_BASE_URL;
installRateLimitRetry(axios);
